export default __webpack_public_path__ + "static/media/runner-girl.a14c7dfe.jpg";